import React, { useContext } from "react";
import { AppContext } from "../AppContext";
import CustomerRatingCard from "./CustomerRatingCard";

const CustomerRating = () => {
  const { activeTab, selectedLocation } = useContext(AppContext);

  return (
    <div className="mt-8 p-4 bg-white shadow-md rounded-lg">
      <h2 className="text-3xl font-semibold text-gray-800">
        <span className="text-primaryOrange">Meet Our</span> Customers
      </h2>
      {/* Add deal content here */}
      <p className="text-gray-600 mt-2">Explore the best deals curated for you!</p>
      <CustomerRatingCard/>
    </div>
  );
};

export default CustomerRating;

// {activeTab === "buy" ? "Buying" : "Rents"}